
import moment from "moment";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "DatePicker",
})
export default class DatePicker extends Vue {
  @Prop() value!: string;
  @Prop({ type: Function, default: () => {} }) onSelect!: any;
  @Prop({
    type: Function,
    default: (date: any) =>
      moment(date, "YYYY-MM-DD").format("ddd").toUpperCase(),
  })
  weekdayFormat!: string;
  @Prop({ type: Boolean }) showAdjacentMonths!: boolean;
  @Prop({ type: Boolean }) range!: boolean;
  @Prop({ type: String }) min!: string;
  @Prop({ type: Boolean, default: false }) readonly!: boolean;

  pickerDate: string | null = null;

  @Emit("input")
  public update(date: string) {
    this.onSelect && this.onSelect();
    return date;
  }
  created() {
    // Only adjust picker date if min prop is provided
    if (this.min) {
      this.adjustPickerDate();
    }
  }

  adjustPickerDate() {
    const minDate = moment(this.min);

    if (!minDate.isValid()) {
      console.warn('DatePicker: Invalid min date provided:', this.min);
      return;
    }

    const endOfMonth = moment().endOf('month');

    // If minDate is after the end of current month, show the month of minDate
    if (minDate.isAfter(endOfMonth)) {
      this.pickerDate = minDate.format('YYYY-MM');
    }
  }
}
